import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import { useNotification } from "@/hooks/useNotification"
import { useMutation } from "@/hooks/useMutation"
import {
  CandidateRejectionTypeEnum,
  ShortlistBulkApplicantionsMutationMutationVariables,
  ShortlistBulkApplicantionsMutationMutation,
  ShortlistBulkApplicantionsMutation,
  ArchiveBulkApplicantionsMutation,
  ArchiveBulkApplicantionsMutationMutation,
  ArchiveBulkApplicantionsMutationMutationVariables,
  RejectBulkApplicantionsMutationMutationVariables,
  RejectBulkApplicantionsMutation,
  RejectBulkApplicantionsMutationMutation,
} from "@/gql"
import { CandidateRejectionTypeEnumReasons } from "@/constants"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"

type Form = {
  rejectionReason: CandidateRejectionTypeEnum
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ManageBulkApplicantActions',
  props: {
  applicantIds: {
    type: Array as PropType<string[]>,
    required: true,
  },
  refetchQueries: {
    type: Object as PropType<RefetchQueryDescription>,
  },
},
  emits: ["clearApplicants"],
  setup(__props, { emit }) {

const props = __props

const { mutate } = useMutation()
const { addSuccess, addError } = useNotification()





const actions = {
  archive: "archive",
  shortlist: "shortlist",
  reject: "reject",
} as const

const form = ref<Form>({
  rejectionReason: CandidateRejectionTypeEnum.SeeYouLater,
})

const applicationAction = ref<(typeof actions)[keyof typeof actions] | null>(null)
const actionLoading = ref(false)

const done = () => {
  applicationAction.value = null
  emit("clearApplicants")
}

const onArchiveApplicants = async () => {
  actionLoading.value = true
  // Mutate
  const result = await mutate<
    ArchiveBulkApplicantionsMutationMutation,
    ArchiveBulkApplicantionsMutationMutationVariables
  >({
    mutation: ArchiveBulkApplicantionsMutation,
    variables: {
      ids: props.applicantIds,
    },
    handlePayloadErrors: true,
    refetchQueries: props.refetchQueries,
  })

  if (!result?.data?.bulkArchiveApplication?.error) {
    addSuccess("Applications archived successfully!")
    done()
  }
  actionLoading.value = false
}

const onShortlistApplicants = async () => {
  actionLoading.value = true
  // Mutate
  const result = await mutate<
    ShortlistBulkApplicantionsMutationMutation,
    ShortlistBulkApplicantionsMutationMutationVariables
  >({
    mutation: ShortlistBulkApplicantionsMutation,
    variables: {
      ids: props.applicantIds,
    },
    handlePayloadErrors: true,
    refetchQueries: props.refetchQueries,
  })

  if (!result?.data?.bulkShortlistApplicant?.error) {
    addSuccess("Applications archived successfully!")
    done()
  }
  actionLoading.value = false
}

const onRejectApplicants = async () => {
  actionLoading.value = true
  // Mutate
  const result = await mutate<
    RejectBulkApplicantionsMutationMutation,
    RejectBulkApplicantionsMutationMutationVariables
  >({
    mutation: RejectBulkApplicantionsMutation,
    variables: {
      ids: props.applicantIds,
      rejectionReason: form.value.rejectionReason,
    },
    handlePayloadErrors: true,
    refetchQueries: props.refetchQueries,
  })

  if (!result?.data?.bulkRejectApplication?.error) {
    addSuccess("Applications archived successfully!")
    done()
  }
  actionLoading.value = false
}

const onApplicationAction = () => {
  if (!props.applicantIds.length) return

  switch (applicationAction.value) {
    case actions.archive:
      onArchiveApplicants()
      break

    case actions.shortlist:
      onShortlistApplicants()
      break

    case actions.reject:
      onRejectApplicants()
      break

    default:
      addError(`Unknown action ${applicationAction.value}`)
      break
  }
}

return { __sfc: true,mutate, addSuccess, addError, props, emit, actions, form, applicationAction, actionLoading, done, onArchiveApplicants, onShortlistApplicants, onRejectApplicants, onApplicationAction, Icon, CandidateRejectionTypeEnumReasons }
}

})